var Config = {
  /** URL */
  ajaxUrl: "//www.aena-s.com/wlwz",
};

window.Config = Config;